import React from 'react';
import { FaRegBell, FaSun, FaMoon, FaBars } from 'react-icons/fa';
import { UserMenu } from './UserMenu';
import { useTheme } from '../../contexts/ThemeContext';

interface HeaderProps {
  setSidebarOpen: (isOpen: boolean) => void;
}

export const Header: React.FC<HeaderProps> = ({ setSidebarOpen }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <header className="h-16 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between px-4 md:px-8">
      <div className="flex items-center">
        <button 
          className="text-gray-500 focus:outline-none md:hidden"
          onClick={() => setSidebarOpen(true)}
        >
          <FaBars size={22} />
        </button>
        <div className="hidden md:block">
          <img 
            src={theme === 'dark' ? '/WaterMark_logo.png' : '/Main_logo.png'} 
            alt="부다페스트한인선교교회 온라인 행정" 
            className="h-8" 
          />
        </div>
      </div>

      <div className="flex items-center gap-x-4 md:gap-x-6">
        <button
          onClick={toggleTheme}
          className="text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white"
          aria-label="Toggle dark mode"
        >
          {theme === 'light' ? <FaMoon size={20} /> : <FaSun size={22} />}
        </button>
        <button className="relative text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white">
          <FaRegBell size={22} />
          <span className="absolute top-0 right-0 block h-2 w-2 rounded-full bg-red-500 ring-2 ring-white"></span>
        </button>
        
        <UserMenu />
      </div>
    </header>
  );
};
